"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINDSET_CONSENTED_CALL_RECORDING_FIXTURE = void 0;
exports.MINDSET_CONSENTED_CALL_RECORDING_FIXTURE = {
    labels: {
        video: "Video Record This Call",
        audio: "Audio Record This Call",
        confirmation: "The other parties must agree. Send for approval",
        approve: "Approve",
    },
    routes: {
        groupCreate: "/mindset/v2/tenants/mindset-lab/group-calls/call-v2/recording-requests",
        groupCurrent: "/mindset/v2/tenants/mindset-lab/group-calls/call-v2/recording-requests/current?userId=requester",
        groupRespond: "/mindset/v2/tenants/mindset-lab/group-calls/call-v2/recording-requests/recording-1/respond",
        directCreate: "/mindset/v1/tenants/mindset-lab/calls/call-v1/recording-requests",
        directCurrent: "/mindset/v1/tenants/mindset-lab/calls/call-v1/recording-requests/current?userId=requester",
        directRespond: "/mindset/v1/tenants/mindset-lab/calls/call-v1/recording-requests/recording-1/respond",
    },
    createBody: {
        requestedByUserId: "requester", requestedMode: "FULL_CALL", mediaKind: "VIDEO",
        expiresInSeconds: 90, idempotencyKey: "recording-video-attempt-1",
    },
    pending: {
        contractVersion: "mindset-communications/v2", id: "recording-1",
        tenantId: "mindset-lab", callId: "call-v2", requestedByUserId: "requester",
        requestedMode: "FULL_CALL", source: "GROUP_V2", mediaKind: "VIDEO",
        consentEpoch: 0, captureState: "IDLE", resolvedMode: null, status: "PENDING",
        participants: [
            { userId: "requester", joinEpoch: 1, status: "PENDING", decidedAt: null },
            { userId: "peer", joinEpoch: 3, status: "PENDING", decidedAt: null },
        ],
        aggregate: {
            requiredParticipantCount: 2, pendingCount: 2, approvedCount: 0, declinedCount: 0,
            revokedCount: 0, expiredCount: 0, unanimousApproved: false,
        },
        requestedAt: "2026-10-01T12:00:00.000Z", expiresAt: "2026-10-01T12:01:30.000Z",
        startedAt: null, stoppedAt: null, revision: 0,
    },
    requesterApproveBody: {
        userId: "requester", joinEpoch: 1, mediaKind: "VIDEO", consentEpoch: 0,
        action: "APPROVE", expectedRevision: 0,
    },
    peerApproveBodyAfterRequester: {
        userId: "peer", joinEpoch: 3, mediaKind: "VIDEO", consentEpoch: 0,
        action: "APPROVE", expectedRevision: 1,
    },
    directUnavailable: {
        error: {
            code: "CONSENTED_RECORDING_UNAVAILABLE",
            message: "Consented whole-call recording is unavailable until the verified media lifecycle adapter is configured",
            details: { source: "DIRECT_V1" },
        },
    },
};
//# sourceMappingURL=consented-call-recording.fixture.js.map